import {SOPutIdentity} from '../../core/identity/so-put-identity';
import {IdentityCore} from './identity.core';
import {SOGetIdentity} from '../../core/identity/so-get-identity';
import {FormField, SelectionOption} from 'lionheartland';
import {putIdentityFormFieldOptions} from './put-identity-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {UserCore} from '../user/user.core';
import {SOGetUser} from '../../core/user/so-get-user';

export class RAPutIdentity extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putIdentityFormFieldOptions);

  RequestClass = SOPutIdentity

  constructor(
    public entityCore: IdentityCore
  ) {
    super();
    if (putIdentityFormFieldOptions.user) {
      putIdentityFormFieldOptions.user.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('provider'),
      this.getFormValueFromIdentifier(
        'user',
        SOGetUser,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}